"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classifier = exports.getChildElement = exports.elementFormatter = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GRID_TYPES = ['Col', 'Row'];

var isGridItem = function isGridItem(el) {
  return el && el.props && GRID_TYPES.indexOf(el.props._name) !== -1;
};

var getType = function getType(el) {
  return el && el.props && el.props._name;
};

var elementFormatter = function elementFormatter(element, _ref) {
  var count = _ref.count,
      index = _ref.index,
      totalWeight = _ref.totalWeight;

  // if the element is anything else than a Col or a Row, return it directly
  if (!isGridItem(element)) {
    return element;
  }

  var type = getType(element); // if not get the weight and define the ratio

  var _element$props = element.props,
      weight = _element$props.weight,
      children = _element$props.children;
  var ratio = weight / totalWeight * 100;
  var last = index + 1 === count;
  var key = "".concat(type, "_").concat(index + 1, "_of_").concat(count);
  var props = {
    children: children,
    key: key,
    last: last
  }; // augment the props with the proper element

  if (type === 'Col') {
    props.width = ratio;
  } else if (type === 'Row') {
    props.height = ratio;
  }

  return _react["default"].cloneElement(element, props);
};

exports.elementFormatter = elementFormatter;

var getChildElement = function getChildElement(child) {
  var childElement = child;

  if (Array.isArray(child)) {
    childElement = child.reduce(function (acc, curr) {
      if (curr) {
        return curr;
      }
    }, null);
  }

  return childElement;
};

exports.getChildElement = getChildElement;

var classifier = function classifier(children) {
  if (!children) return null;
  var count = children.length; // if the children is a single element, a function - it's a react Element and not a DOM element.
  // if it's a grid item, we format it directly.

  if (children instanceof Function && isGridItem(children)) {
    return elementFormatter(children, {
      count: count,
      index: 0
    });
  } else if (children instanceof Array) {
    var childrenTypes = new Set();
    var totalWeight = 0; // for each children, we get the total count of the weight across all elements
    // and make sure that all children are of the same type by adding the name to a Set...

    children.forEach(function (child) {
      var childElement = getChildElement(child);
      if (!isGridItem(childElement)) return;
      var _childElement$props = childElement.props,
          _name = _childElement$props._name,
          weight = _childElement$props.weight;
      childrenTypes.add(_name);
      totalWeight += weight;
    }); // ...and checking is length

    if (childrenTypes.size > 1) {
      /* eslint-disable no-console */
      console.warn("Received ".concat(childrenTypes, ", all siblings Grid component should") + "be of the same type (all Col or all Row) per group of siblings");
      return null;
    }

    return children.map(function (child, index) {
      var childElement = getChildElement(child); // we make sure to not return null elements here

      if (child) {
        return elementFormatter(childElement, {
          count: count,
          index: index,
          totalWeight: totalWeight
        });
      }

      return false;
    });
  }

  return children;
};

exports.classifier = classifier;

//# sourceMappingURL=GridUtils.js.map